import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import LegalPageLayout from "../Components/LegalPageLayout";

function PrivacyEUC() {
  return (
    <LegalPageLayout
      titleId="privacy-euc-title"
      icon={faUserShield}
      title="Privacy Policy (Energy Usage Calculator)"
      description={
        <p>
          Your privacy is our priority. This page explains how the app handles
          information.
        </p>
      }
    >
      <p className="effective-date">Effective Date: June 18, 2026</p>
      <p>
        Energy Usage Calculator is a mobile application developed and operated
        by MileSoft. MileSoft is the data controller for personal information
        processed through Energy Usage Calculator. For privacy requests, data
        protection officer (DPO) requests, and controller contact purposes,
        email us at{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>.
      </p>

      <h5>Categories of Personal Data We Collect</h5>
      <p>The app may process these categories of data:</p>
      <ul>
        <li>
          <strong>Energy and appliance data:</strong> kilowatt-hours (kWh),
          usage patterns, appliance details, and calculation inputs. This data
          is stored locally on your device and is not transmitted to MileSoft
          servers.
        </li>
        <li>
          <strong>Device identifiers:</strong> Device ID and other device or app
          identifiers where supplied by platform tooling.
        </li>
        <li>
          <strong>App activity:</strong> limited interactions used for app
          operation, security, compatibility, and reliability.
        </li>
        <li>
          <strong>Crash logs and diagnostics:</strong> crash reports, error
          logs, app version, device type, and operating system.
        </li>
      </ul>

      <h5>How We Use Information and Legal Basis</h5>
      <p>
        We use energy usage information to perform calculations and show reports
        on your device. We use limited technical information, if collected, to
        maintain app reliability, protect against misuse, respond to support
        requests, and comply with legal obligations. Our legal basis for
        processing may include performance of a contract or requested service,
        consent, legitimate interests in operating and securing the app, legal
        obligations, and processing requested by you.
      </p>

      <h5>Data Sharing, Sales, and Targeted Advertising</h5>
      <p>
        MileSoft does not sell personal information. Energy usage data stored
        locally on your device is not shared with MileSoft or unrelated third
        parties. We may share limited diagnostic or technical information with
        service providers needed to operate the app, when required by law, to
        protect users and systems, or during a business transfer.
      </p>
      <p>
        You may opt out of any sale, sharing, or targeted advertising use of
        personal information by emailing{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>. We
        will honor applicable opt-out rights even though we do not sell personal
        information.
      </p>

      <h5>Security and Encryption</h5>
      <p>
        Energy usage data is stored locally on your device. We recommend using
        device passwords and operating system security features. Where
        information is sent to MileSoft services or service providers, we use
        HTTPS and encryption in transit where available, along with reasonable
        safeguards. No system can guarantee absolute security.
      </p>

      <h5>Data Retention</h5>
      <p>
        Locally stored energy usage data remains on your device until you edit
        or delete it or uninstall the app. Diagnostic and technical information,
        if collected, is retained only as long as needed for app reliability,
        security, legal compliance, dispute resolution, backups, or business
        records.
      </p>

      <h5>Your Privacy Rights</h5>
      <h6>Right to Know About Data Sharing</h6>
      <p>
        You have the right to ask whether MileSoft shares your personal
        information and, where applicable, the categories of personal
        information shared, the purposes for sharing, and the categories of
        recipients. You may make this request using the contact details below.
      </p>
      <p>
        Depending on where you live, including under the GDPR, CCPA/CPRA, VCDPA,
        LGPD, and other applicable privacy laws, you may have the right to
        request access to personal information we collect, request correction or
        rectification of inaccurate information, request deletion, request a
        portable copy, object to or restrict certain processing, withdraw
        consent where processing is based on consent, and know whether personal
        information is sold or shared.
      </p>
      <p>
        California residents may exercise CCPA/CPRA rights to know, access,
        correct, delete, and opt out of sale or sharing. Virginia residents may
        exercise VCDPA rights to access, correct, delete, obtain a copy, and opt
        out of targeted advertising, sale, or certain profiling. Users in Brazil
        may exercise LGPD rights, including confirmation, access, correction,
        anonymization, deletion, portability, information about sharing, and
        consent withdrawal. Users in the EEA or UK may exercise GDPR rights,
        including access, rectification, erasure, restriction, objection,
        portability, and the right to lodge a complaint with a supervisory
        authority.
      </p>
      <p>
        To make a privacy rights request, contact{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>.
      </p>

      <h5>Children's Privacy</h5>
      <p>
        Energy Usage Calculator is not intended for children under 13. We do not
        knowingly collect personal information from children. If we learn that a
        child has provided personal information without appropriate consent, we
        will take reasonable steps to delete it.
      </p>

      <h5>Changes to This Privacy Policy</h5>
      <p>
        MileSoft may update this Privacy Policy from time to time. When we
        update it, we will revise the effective date and may notify users
        through the app, email, or another reasonable method.
      </p>

      <h5>Contact Us</h5>
      <p>
        <strong>Company and App Provider:</strong> MileSoft
        <br />
        <strong>App:</strong> Energy Usage Calculator
        <br />
        <strong>Controller and DPO Contact:</strong>{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>
        <br />
        <strong>Location:</strong> Malawi
      </p>
    </LegalPageLayout>
  );
}

export default PrivacyEUC;
